export const safeNav = (url: string) => {
  if (window.location.pathname !== url) {
    window.location.href = url;
  }
};
export const safeToLogin = (ignoreNext: boolean = true) => {
  const next = ignoreNext ? window.location.pathname + window.location.search : '/';
  if (window.location.pathname.startsWith('/tiangong')) {
    //管理后台跳转到 rbac 登录
    window.location.href = `/rbac/login?next=${window.location.href}`;
  } else {
    safeNav(`/login?next=${next}`);
  }
};
